<template>
  <on-click-outside :do="close">
    <div>
      <div class="input-group date">
        <input
          type="text"
          class="form-control"
          :value="value"
          @input="onInputDate"
          v-bind="{
            placeholder: format,
            ...$attrs
          }"
          ref="inputDatePicker"
          @focus="open"
        />
        <div class="input-group-addon" @click="open">
          <i class="fa fa-calendar"></i>
        </div>
      </div>
      <div
        class="bootstrap-datetimepicker-widget dropdown-menu bottom date-picker-dropdown"
        ref="dropdown"
        v-show="isOpen"
      >
        <ul class="list-unstyled">
          <li class="collapse in">
            <c-date-picker @change="selectDate" :date-prop="value" :format="format" />
          </li>
          <!-- <li class="picker-switch accordion-toggle">
            <table class="table-condensed">
              <tbody>
                <tr>
                  <td>
                    <a data-action="togglePicker" title="Select Time"
                      ><span class="glyphicon glyphicon-time"></span
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </li>
          <li class="collapse">
            <div class="timepicker">
              <div class="timepicker-picker">
                <table class="table-condensed">
                  <tr>
                    <td>
                      <a
                        href="#"
                        tabindex="-1"
                        title="Increment Hour"
                        class="btn"
                        data-action="incrementHours"
                        ><span class="glyphicon glyphicon-chevron-up"></span
                      ></a>
                    </td>
                    <td class="separator"></td>
                    <td>
                      <a
                        href="#"
                        tabindex="-1"
                        title="Increment Minute"
                        class="btn"
                        data-action="incrementMinutes"
                        ><span class="glyphicon glyphicon-chevron-up"></span
                      ></a>
                    </td>
                    <td class="separator"></td>
                  </tr>
                  <tr>
                    <td>
                      <span
                        class="timepicker-hour"
                        data-time-component="hours"
                        title="Pick Hour"
                        data-action="showHours"
                        >07</span
                      >
                    </td>
                    <td class="separator">:</td>
                    <td>
                      <span
                        class="timepicker-minute"
                        data-time-component="minutes"
                        title="Pick Minute"
                        data-action="showMinutes"
                        >33</span
                      >
                    </td>
                    <td>
                      <button
                        class="btn btn-primary"
                        data-action="togglePeriod"
                        tabindex="-1"
                        title="Toggle Period"
                      >
                        PM
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a
                        href="#"
                        tabindex="-1"
                        title="Decrement Hour"
                        class="btn"
                        data-action="decrementHours"
                        ><span class="glyphicon glyphicon-chevron-down"></span
                      ></a>
                    </td>
                    <td class="separator"></td>
                    <td>
                      <a
                        href="#"
                        tabindex="-1"
                        title="Decrement Minute"
                        class="btn"
                        data-action="decrementMinutes"
                        ><span class="glyphicon glyphicon-chevron-down"></span
                      ></a>
                    </td>
                    <td class="separator"></td>
                  </tr>
                </table>
              </div>
              <div class="timepicker-hours" style="display: none;">
                <table class="table-condensed">
                  <tr>
                    <td data-action="selectHour" class="hour">12</td>
                    <td data-action="selectHour" class="hour">01</td>
                    <td data-action="selectHour" class="hour">02</td>
                    <td data-action="selectHour" class="hour">03</td>
                  </tr>
                  <tr>
                    <td data-action="selectHour" class="hour">04</td>
                    <td data-action="selectHour" class="hour">05</td>
                    <td data-action="selectHour" class="hour">06</td>
                    <td data-action="selectHour" class="hour">07</td>
                  </tr>
                  <tr>
                    <td data-action="selectHour" class="hour">08</td>
                    <td data-action="selectHour" class="hour">09</td>
                    <td data-action="selectHour" class="hour">10</td>
                    <td data-action="selectHour" class="hour">11</td>
                  </tr>
                </table>
              </div>
              <div class="timepicker-minutes" style="display: none;">
                <table class="table-condensed">
                  <tr>
                    <td data-action="selectMinute" class="minute">00</td>
                    <td data-action="selectMinute" class="minute">05</td>
                    <td data-action="selectMinute" class="minute">10</td>
                    <td data-action="selectMinute" class="minute">15</td>
                  </tr>
                  <tr>
                    <td data-action="selectMinute" class="minute">20</td>
                    <td data-action="selectMinute" class="minute">25</td>
                    <td data-action="selectMinute" class="minute">30</td>
                    <td data-action="selectMinute" class="minute">35</td>
                  </tr>
                  <tr>
                    <td data-action="selectMinute" class="minute">40</td>
                    <td data-action="selectMinute" class="minute">45</td>
                    <td data-action="selectMinute" class="minute">50</td>
                    <td data-action="selectMinute" class="minute">55</td>
                  </tr>
                </table>
              </div>
            </div>
          </li>-->
        </ul>
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import Popper from 'popper.js'
import OnClickOutside from '@/components/OnClickOutside.vue'
import CDatePicker from '@/components/DatePicker'

export default {
  name: 'TsDatePickerInput',
  inheritAttrs: false,
  components: { CDatePicker, OnClickOutside },
  props: {
    value: {
      type: String | Number
    },
    closeOnSelect: {
      type: Boolean
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY'
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  beforeDestroy() {
    this.popper !== undefined && this.popper.destroy()
  },
  methods: {
    open() {
      if (this.$attrs.disabled !== undefined && this.$attrs.disabled !== false) {
        return
      }

      if (this.isOpen) {
        return
      }

      this.isOpen = true
      this.$nextTick(() => {
        this.setupPopper()
      })
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.inputDatePicker, this.$refs.dropdown, {
          placement: 'bottom',
          positionFixed: true,
          modifiers: {
            offset: {
              enabled: true,
              fn: data => {
                data.offsets.popper.left = data.offsets.reference.left
                data.offsets.popper.right = data.offsets.reference.right

                return data
              },
              order: 840
            }
          }
        })
      } else {
        this.popper.scheduleUpdate()
      }
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
    },
    selectDate(date) {
      this.$emit('input', date.format(this.format))

      if (this.closeOnSelect) this.close()
    },
    onInputDate(e) {
      // ^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$
      // ^(?=\d{2}([-.,\/])\d{2}\1\d{4}$)(?:0[1-9]|1\d|[2][0-8]|29(?!.02.(?!(?!(?:[02468][1-35-79]|[13579][0-13-57-9])00)\d{2}(?:[02468][048]|[13579][26])))|30(?!.02)|31(?=.(?:0[13578]|10|12))).(?:0[1-9]|1[012]).\d{4}$

      let dateRegex = /^(?=\d{2}([-.,\/])\d{2}\1\d{4}$)(?:0[1-9]|1\d|[2][0-8]|29(?!.02.(?!(?!(?:[02468][1-35-79]|[13579][0-13-57-9])00)\d{2}(?:[02468][048]|[13579][26])))|30(?!.02)|31(?=.(?:0[13578]|10|12))).(?:0[1-9]|1[012]).\d{4}$/

      if (!dateRegex.test(e.target.value)) return

      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-picker-dropdown {
  top: 7px !important;
  z-index: 1000;
}
</style>
